export const ADMIN_DASHBOARD_TABS = Object.freeze(
  {
    ROLES: 'Roles',
    WORKGROUPS: 'Workgroups',
    PERMISSIONS: 'Permissions',
    MANAGE_MEMBERS: 'Manage Members',
    PROCEDURE_MASTER: 'Procedure Master',
    ORDERING_PHYSICIANS: 'Ordering Physicians',
    ANALYTICS: 'Analytics',
    ACCOUNT_DETAILS: 'Account Details',
  }
);

export const tabOrder = [
  { name: ADMIN_DASHBOARD_TABS.ROLES, index: 0 },
  { name: ADMIN_DASHBOARD_TABS.WORKGROUPS, index: 1 },
  { name: ADMIN_DASHBOARD_TABS.PERMISSIONS, index: 2 },
  { name: ADMIN_DASHBOARD_TABS.MANAGE_MEMBERS, index: 3 },
  { name: ADMIN_DASHBOARD_TABS.PROCEDURE_MASTER, index: 4 },
  { name: ADMIN_DASHBOARD_TABS.ORDERING_PHYSICIANS, index: 5 },
  { name: ADMIN_DASHBOARD_TABS.ANALYTICS, index: 6 },
  { name: ADMIN_DASHBOARD_TABS.ACCOUNT_DETAILS, index: 7 },
];

export const allowedTabsForCustomRoles = new Set([
  ADMIN_DASHBOARD_TABS.ACCOUNT_DETAILS,
]);

export default ADMIN_DASHBOARD_TABS;
